/* shto-compare: the chair comparison table scrolls sideways under its frozen chair column.
   - Arrows page through the columns: "next" brings the first column that isn't fully shown to the frozen column's edge,
     "previous" goes back the same way. Each is disabled at its end.
   - A sideways drag (mouse) or swipe (touch) moves the table and settles on a column's edge when released.
   - Touch screens use the browser's own sideways scroll (momentum, any angle); an up-down swipe still scrolls the page. The
     mouse drag only starts once the pointer has clearly moved sideways. A trackpad's sideways scroll works natively.
   The address is never changed. */
(function () {
  if (window.ShtoCompare) return;
  window.ShtoCompare = true;

  function init(root) {
    if (root.shtoCompare) return;
    var scroller = root.querySelector('[data-shto-compare-scroll]');
    var frame = root.querySelector('[data-shto-compare-frame]');
    var prev = root.querySelector('[data-shto-compare-prev]');
    var next = root.querySelector('[data-shto-compare-next]');
    if (!scroller || !frame) return;
    root.shtoCompare = true;
    scroller.setAttribute('data-shto-compare-on', '');

    function cols() { return Array.prototype.slice.call(scroller.querySelectorAll('[data-shto-compare-col]')); }
    function maxLeft() { return Math.max(0, scroller.scrollWidth - scroller.clientWidth); }
    function frozen() { var c = scroller.querySelector('.shto-compare__corner'); return c ? c.offsetWidth : 0; }
    // Where each column starts, measured from the first one (so 0 shows column 1 next to the frozen chair column).
    function edges() {
      var list = cols(), base = list.length ? list[0].offsetLeft : 0;
      return list.map(function (c) { return { left: c.offsetLeft - base, right: c.offsetLeft - base + c.offsetWidth }; });
    }
    function stops() {
      var max = maxLeft();
      var out = edges().map(function (e) { return Math.min(max, e.left); });
      out.push(max);
      return out.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    }
    function go(left) {
      left = Math.max(0, Math.min(maxLeft(), Math.round(left)));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    }
    function view() { return scroller.clientWidth - frozen(); }

    function pageNext() {
      var here = scroller.scrollLeft, right = here + view(), list = edges(), target = null;
      for (var i = 0; i < list.length; i++) if (list[i].right > right + 1) { target = list[i].left; break; }
      if (target === null || target <= here + 1) {
        var s = stops(); target = maxLeft();
        for (var j = 0; j < s.length; j++) if (s[j] > here + 1) { target = s[j]; break; }
      }
      go(target);
    }
    function pagePrev() {
      var here = scroller.scrollLeft, s = stops(), target = 0;
      for (var i = 0; i < s.length; i++) if (s[i] >= here - view() - 1) { target = s[i]; break; }
      if (target >= here - 1) { target = 0; for (var j = s.length - 1; j >= 0; j--) if (s[j] < here - 1) { target = s[j]; break; } }
      go(target);
    }

    var raf = 0;
    function update() {
      raf = 0;
      var here = scroller.scrollLeft, max = maxLeft();
      var atStart = here <= 1, atEnd = here >= max - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      frame.classList.toggle('is-scrolled', !atStart);
      frame.classList.toggle('is-end', atEnd);
    }
    function later() { if (!raf) raf = requestAnimationFrame(update); }
    scroller.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    if (prev) prev.addEventListener('click', pagePrev);
    if (next) next.addEventListener('click', pageNext);
    update();

    // Drag / swipe.
    var drag = null, suppressClick = false;
    scroller.addEventListener('pointerdown', function (e) {
      // Touch screens scroll the table natively (Kevin 2026-10-06: the custom swipe was hard to use on phones); the drag is for a mouse.
      if (e.pointerType !== 'mouse') return;
      if (e.button !== undefined && e.button !== 0) return;
      if (maxLeft() < 1) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, left: scroller.scrollLeft, lastX: e.clientX, lastT: e.timeStamp, v: 0, on: false };
      suppressClick = false;
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; } // up-down: the page's
        if (Math.abs(dx) < 8) return;
        drag.on = true;
        scroller.classList.add('is-dragging');
        try { scroller.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var dt = Math.max(e.timeStamp - drag.lastT, 1);
      drag.v = (e.clientX - drag.lastX) / dt;
      drag.lastX = e.clientX; drag.lastT = e.timeStamp;
      scroller.scrollLeft = drag.left - dx;
    });
    function end(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      scroller.classList.remove('is-dragging');
      if (!d.on) return;
      suppressClick = true;
      var here = scroller.scrollLeft, s = stops(), moved = here - d.left, target;
      var forward = d.v < -0.2 || (d.v <= 0.2 && moved > 24);
      var back = d.v > 0.2 || (d.v >= -0.2 && moved < -24);
      if (forward) { target = s[s.length - 1]; for (var i = 0; i < s.length; i++) if (s[i] > here + 1) { target = s[i]; break; } }
      else if (back) { target = 0; for (var j = s.length - 1; j >= 0; j--) if (s[j] < here - 1) { target = s[j]; break; } }
      else target = s.reduce(function (a, b) { return Math.abs(b - here) < Math.abs(a - here) ? b : a; }, s[0]);
      go(target);
    }
    scroller.addEventListener('pointerup', end);
    scroller.addEventListener('pointercancel', function (e) { if (drag && e.pointerId === drag.id) { drag = null; scroller.classList.remove('is-dragging'); } });
    scroller.addEventListener('lostpointercapture', function (e) { if (e.target === scroller) end(e); });
    scroller.addEventListener('click', function (e) { if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; } }, true);
    scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-shto-compare]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
